<div
	#moveElement
	class="btn btn-icon me-1 mover-control"
	tabindex="-1"
	title="Move modal"
	(mousedown)="startDragReposition($event, moveElement)"
>
	<i aria-hidden="true" class="far fa-arrows-alt"></i>
</div>
